/**
 * «Mostrar solo en días específicos» (Programación de la guía).
 *
 * `campaignWeekdays` viene del backend como array de 0..6 (0 = domingo, igual
 * que `Date#getDay()`); `null`/ausente = todos los días. Se evalúa ACÁ, con la
 * hora LOCAL del visitante, porque el backend no conoce su zona horaria.
 * Función pura para poder testearla con una fecha fija.
 */
export function isWeekdayAllowed(
  campaignWeekdays: number[] | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!campaignWeekdays || campaignWeekdays.length === 0) return true;
  return campaignWeekdays.includes(now.getDay());
}
